<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    @close="closeDialog"
    :close-on-click-modal="false"
    width="45%"
  >
    <el-form
      ref="curdForm"
      size="small"
      :model="curdForm"
      label-position="right"
      label-width="100px"
    >
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="作业："
            prop="attachmentList"
            required
          >
            <upload :limit="1" :path="'class/work'" v-model="attachmentList" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click.native="createData()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "../Bus";
import { uploadWork } from "@/api/classWork";
import Upload from "@/components/upload/index";

export default {
  components: { butn, Upload },
  data() {
    return {
      curdTitle: "作业上传",
      CUFlag: false,
      curdForm: {
        userId: "",
        workId: ""
      },
      attachmentList: []
    };
  },
  created() {
    var _this = this;
    Bus.$on("uploadWork", function(item) {
      _this.$nextTick(() => {
        _this.CUFlag = true;
        _this.curdForm.userId = item.userId;
        _this.curdForm.workId = item.workId;
      });
    });
  },
  methods: {
    createData() {
      if (this.attachmentList.length > 0) {
        this.loading = true;
        let params = {
          ...this.curdForm,
          attachment: JSON.stringify(this.attachmentList)
        };
        uploadWork(params).then(res => {
          this.loading = false;
          if (res && res.code == 0) {
            this.$message.success(res.msg);
            Bus.$emit("reloadPageWork");
            this.closeDialog();
          }
        });
      } else {
        this.$message({
          message: "请选择上传文件",
          type: "warning"
        });
      }
    },
    closeDialog() {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs["curdForm"].resetFields();
      this.attachmentList = [];
    }
  },
  beforeDestroy() {
    Bus.$off("uploadWork");
  }
};
</script>

<style lang="scss" scoped></style>
